import { cn } from '@/lib/cn';

type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'error' | 'purple';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-dark-600 text-gray-300',
  primary: 'bg-primary-500/15 text-primary-400 border border-primary-500/30',
  success: 'bg-success-500/15 text-success-400 border border-success-500/30',
  warning: 'bg-warning-500/15 text-warning-400 border border-warning-500/30',
  error: 'bg-error-500/15 text-error-400 border border-error-500/30',
  purple: 'bg-accent-500/15 text-accent-400 border border-accent-500/30',
};

export function Badge({ variant = 'default', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        variantStyles[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
